// extracted by mini-css-extract-plugin
export default {"logo":"APLogo_logo__F1l+8"};